export default "https://cdn-static.gokick.com/assets/510b01776e4307c2b342e37a2ed4ce502ef69aad/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";